import * as ng from 'angular';
import * as Slider from 'bootstrap-slider';

ng.module('e360')
   .directive('slider', sliderDirective);

export function sliderDirective() {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: sliderDirectiveLink
   };
}

function sliderDirectiveLink(
   scope:ng.IScope,
   element:ng.IAugmentedJQuery,
   attrs:ng.IAttributes,
   ctrl:ng.INgModelController
) {
   let slider = new Slider(element[0], {
      min: parseFloat(attrs.sliderMin),
      max: parseFloat(attrs.sliderMax),
      step: parseFloat(attrs.sliderStep),
      tooltip: 'hide'
   });

   slider.on('change', () => {
      ctrl.$setViewValue(slider.getValue());
   });

   ctrl.$formatters.push((v) => {
      slider.setValue(v);
   });
}
